<template>
  <div>
    <d-row>
      <d-col lg="9">

        <h5 class="mt-2">Business information</h5>
        <div v-if="!fields.vatID || !fields.companyName" class="bg bg-danger text-white p-2 mb-3">
          please compelete these fields:
          <span v-if="!fields.vatID"> VAT -  </span>
          <span v-if="!fields.companyName"> companyName  </span>
        </div>
        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Legal company name</strong></d-col>
          <d-col>
            <d-input v-model="fields.companyName" />
          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Legal entity type</strong></d-col>
          <d-col>
            {{ parking.legalEntity ? parking.legalEntity : 'N/A'}}  {{ parking.legalEntitySolo  ? ' (Solo Trader)' : ''}}


          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>E-mail</strong></d-col>
          <d-col>
            <d-input v-model="fields.email" />
          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Chamber of Commerce</strong></d-col>
          <d-col>
            <d-input v-model="fields.cocID" />

          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>VAT</strong></d-col>
          <d-col>
            <d-input v-model="fields.vatID" />

          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Bank country</strong></d-col>
          <d-col>
            <v-country-select id="country" v-model="fields.bankCountry" autocomplete="off" />
          </d-col>
        </d-row>



        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Bank account</strong></d-col>
          <d-col>
            <d-input v-model="fields.bankAccount" />
          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>SWIFT/BIC</strong></d-col>
          <d-col>
            <d-input v-model="fields.swift" />
          </d-col>
        </d-row>
        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Payment Type</strong></d-col>
          <d-col>
            <d-select @change=" paymentProvider=$event" v-model="fields.paymentProvider">
              <option value="stripe">
                Stripe
              </option>
              <option value="hipay" >
                HiPay
              </option>
          </d-select>
          </d-col>
      </d-row>
        <d-row class="mb-2" v-if="fields.paymentProvider=='stripe' && paymentProviderSecretKeyVisible">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Stripe Secret Key (Brazilian providers Only):</strong></d-col>
          <d-col>
            <d-input v-model="fields.paymentProviderSecretKey" autocomplete="off" />
          </d-col>
        </d-row>
      <d-row class="mb-2" v-if="fields.paymentProvider=='stripe'">
        <d-col lg="3" style="display: flex; align-items: center;"><strong>Stripe Connect ID:</strong></d-col>
        <d-col>
          <d-input v-model="fields.paymentProviderID" autocomplete="off" />
        </d-col>
      </d-row>

      <div v-else>
        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>HiPay Account ID</strong></d-col>
          <d-col>
            {{ parking.hiPayAccountID ? parking.hiPayAccountID : "N/A"}}
          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>HiPay Status</strong></d-col>
          <d-col>
            <div v-if="parking.hiPayAccount">
              <div v-if="parking.hiPayAccount.code !== 0">
                <d-badge theme="danger">
                  Error: {{parking.hiPayAccount.message}}
                </d-badge>
              </div>
              <div v-else>
                <d-badge class="mr-3" :theme="( parking.hiPayAccount.activated == 0 ) ? 'success' : 'warning' ">{{"Activated: " + parking.hiPayAccount.activated}}</d-badge>
                <d-badge class="mr-3" :theme="( parking.hiPayAccount.identified == 1 ) ? 'success' : 'warning' ">{{"Identified: " + parking.hiPayAccount.identified}}</d-badge>
                <d-badge class="mr-3" :theme="( parking.hiPayAccount.bankInfoValidated == 1 ) ? 'success' : 'warning' ">{{"Bank info validated: " + parking.hiPayAccount.bankInfoValidated }}</d-badge>
              </div>
            </div>
            <div v-else>N/A</div>
          </d-col>
        </d-row>
      </div>

      <d-row class="mb-2">
        <d-col lg="3" style="display: flex; align-items: center;"><strong>Pricing Model: </strong></d-col>
        <d-col class="d-flex space-between">
          <label class="mr-1">Static</label> <d-radio value="Static" v-model="fields.priceMethod" />
          <label class="mr-1">Fair</label> <d-radio value="Fair" v-model="fields.priceMethod" />
          <label class="mr-1">Starting date</label> <d-radio value="StartingDate" v-model="fields.priceMethod" />
        </d-col>
      </d-row>


      <d-row class="mb-2">
        <d-col lg="3" style="display: flex; align-items: center;"><strong>Is week 8 days?: </strong></d-col>
        <d-col class="d-flex space-between">
          <d-checkbox v-model="fields.isWeek8Days" />
        </d-col>
      </d-row>

        <h5 class="mt-5">Business owner</h5>
        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Gender</strong></d-col>
          <d-col>
            <v-custom-select id="gender" :items="genders" v-model="fields.owner.gender" autocomplete="off" />
          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>First name</strong></d-col>
          <d-col>
            <d-input v-model="fields.owner.firstName" />

          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Last name</strong></d-col>
          <d-col>
            <d-input v-model="fields.owner.lastName" />

          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;" ><strong>Birthdate</strong></d-col>
          <d-col>
            <d-datepicker v-model="fields.owner.birthdate" placeholder="Please select a date" format="dd-MM-yyyy" />
          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>E-mail</strong></d-col>
          <d-col>
            <d-input v-model="fields.owner.email" />
          </d-col>
        </d-row>


        <h5 class="mt-5">Administrative contact</h5>
        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Gender</strong></d-col>
          <d-col>
            <v-custom-select id="gender" :items="genders" v-model="fields.administrativeContact.gender" autocomplete="off" />
          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>First name</strong></d-col>
          <d-col>
            <d-input v-model="fields.administrativeContact.firstName" />

          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Last name</strong></d-col>
          <d-col>
            <d-input v-model="fields.administrativeContact.lastName" />

          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;" ><strong>Birthdate</strong></d-col>
          <d-col>
            <d-datepicker v-model="fields.administrativeContact.birthdate" placeholder="Please select a date" format="dd-MM-yyyy" />
          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>E-mail</strong></d-col>
          <d-col>
            <d-input v-model="fields.administrativeContact.email" />
          </d-col>
        </d-row>

        <h5 class="mt-5">Settings</h5>
        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Commission</strong></d-col>
          <d-col>
            <d-input-group append="%">
              <d-input type="number" v-model="fields.commission"  />
            </d-input-group>

          </d-col>
        </d-row>

        <d-row class="mb-2">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Currency</strong></d-col>
          <d-col>
            <v-custom-select id="currency" :items="currencies" v-model="fields.currency" autocomplete="off"  />

          </d-col>
        </d-row>

        <d-row class="mb-3">
          <d-col lg="3" style="display: flex; align-items: center;"><strong>Language</strong></d-col>
          <d-col>
            <v-custom-select id="locale" :items="languages" v-model="fields.locale" autocomplete="off"  />
          </d-col>
        </d-row>

      </d-col>
    </d-row>

    <d-row class="mt-4 mb-2">
      <v-feedback class="col-lg-12" :bus="bus"></v-feedback>
    </d-row>

    <d-row>
      <d-col lg="9" class="d-flex justify-content-between">
        <d-button theme="primary" @click="onSubmit" :disabled="submitting">Save changes</d-button>
<!--        <d-button-->
<!--          v-if="inviteBtn"-->
<!--          @click="onInvite">-->
<!--          Invite provider (ROOSH products)-->
<!--        </d-button>-->
      </d-col>
    </d-row>
  </div>
</template>

<script>
	import HiPay from "~/components/hipaySettings";
  import Vue from "vue";
  import mainOidc from "@/auth";

  export default {
		name: "hipay",

    props: {
      parking: {
        required: true,
        type: Object,
      },
    },

    data: function() {
		  return {
        paymentProviderSecretKeyVisible:false,
        userEmail : '',
		    submitting: false,
        bus: new Vue(),
		    currencies: HiPay.currencies,
        languages: HiPay.languages,
        genders: HiPay.genders,
		    fields: {
		      owner: {
            gender: '',
            firstName: '',
            lastName: '',
            birthdate: '',
            email: '',
          },
          administrativeContact: {
            gender: '',
            firstName: '',
            lastName: '',
            birthdate: '',
            email: '',
          },
          email: '',
          companyName: '',
          cocID: '',
          bankCountry: '',
          bankAccount: '',
          swift: '',
          vatID: '',
          commission: '',
          locale: '',
          paymentProvider:'',
          paymentProviderID:'',
          paymentProviderSecretKey:'',
          priceMethod:'',
          isWeek8Days:true

        },
        inviteBtn: false,
      }
    },

    created() {
      const allowedEmails = process.env.VUE_APP_ALLOWED_EMAILS && process.env.VUE_APP_ALLOWED_EMAILS.split(',') || [];
      this.fields.owner.firstName = this.parking.owner.firstName,
      this.fields.owner.lastName = this.parking.owner.lastName,
      this.fields.owner.birthdate = (this.parking.owner.birthdate != "0001-01-01T00:00:00Z" && this.parking.owner.birthdate !== null) ? new Date(this.parking.owner.birthdate) : null
      this.fields.owner.gender = String(this.parking.owner.gender)
      this.fields.owner.email = String(this.parking.owner.email)

      this.fields.currency = String(this.parking.currency)
      this.fields.locale = String(this.parking.locale)
      this.fields.email = String(this.parking.email)
      this.fields.cocID = this.parking.cocID
      this.fields.bankCountry = this.parking.bankCountry
      this.fields.bankAccount = this.parking.bankAccount
      this.fields.swift = this.parking.swift
      this.fields.vatID = this.parking.vatID
      this.fields.commission = this.parking.commission
      this.fields.companyName = this.parking.legalName

      this.fields.administrativeContact.firstName = this.parking.administrativeContact.firstName,
      this.fields.administrativeContact.lastName = this.parking.administrativeContact.lastName,
      this.fields.administrativeContact.birthdate = (this.parking.administrativeContact.birthdate != "0001-01-01T00:00:00Z" && this.parking.administrativeContact.birthdate !== null) ? new Date(this.parking.administrativeContact.birthdate) : null
      this.fields.administrativeContact.gender = String(this.parking.administrativeContact.gender)
      this.fields.administrativeContact.email = String(this.parking.administrativeContact.email)

      this.inviteBtn = (this.fields.locale !== '' &&  this.fields.email !== '') ? true: false;
      this.fields.paymentProvider = this.parking.paymentProvider,
      this.fields.paymentProviderID = this.parking.paymentProviderID
      this.fields.paymentProviderSecretKey = this.parking.paymentProviderSecretKey
      this.fields.priceMethod = this.parking.priceMethod
      this.fields.isWeek8Days = this.parking.isWeek8Days

      this.userEmail = mainOidc.user.profile.email,
      //  as a workaround and for security reasons , display this field only to some users (for the time being mikaeil and amin)
      //  todo : improve how list of emails are retrieved. for the time being it's fine
      this.paymentProviderSecretKeyVisible = allowedEmails.includes(this.userEmail) ? true : false;

    },
    methods: {

      // Map locale to first two chars
		  mapLocale: function(val) {

        let mappedLocale = ''
        if (val !== '' && (val.substring(0,2) === val.substring(3,5).toLowerCase())) {
          mappedLocale = val.substring(0,2)
        } else {
          mappedLocale = val
        }

        return mappedLocale;
      },

      onInvite: function () {

        const variables = {
          id: this.parking.id,
          locale: this.mapLocale(this.fields.locale)
        }

        try {
          const data = this.$apollo.query({
            query: require('~/graphql/parkings/InviteProvider.gql'), variables, fetchPolicy: 'no-cache'
          }).then(data => {
            if (data.data.inviteProvider.success) {
              this.bus.$emit('submitData', {type: 'success', message: `An e-mail invite has been sent`})
            } else {
              this.bus.$emit('submitData', {type: 'warning', message: 'Something went wrong, the provider has NOT been invited'})
              this.submitting = false;
            }
          })
        } catch (error) {
          this.bus.$emit('submitData', {type: 'warning', message: 'Error: ' + error})
          this.submitting = false;
        }
      },

      onSubmit: async function (event) {
        event.preventDefault();

        // Assemble the GraphQL variables and add the required values
        const variables = {
          id: this.parking.id,
          legalName: this.fields.companyName,
          email: this.fields.email,
          locale: this.fields.locale,

          currency: this.fields.currency,
          cocID: this.fields.cocID,
          bankCountry: this.fields.bankCountry,
          bankAccount: this.fields.bankAccount,
          swift: this.fields.swift,
          vatID: this.fields.vatID,
          commission: this.fields.commission === '' ? 0: parseInt(this.fields.commission),
          paymentProvider:this.fields.paymentProvider,
          paymentProviderID: this.fields.paymentProviderID,
          paymentProviderSecretKey: this.fields.paymentProviderSecretKey,
          priceMethod: this.fields.priceMethod,
          isWeek8Days:this.fields.isWeek8Days,


          owner: {
            firstName: this.fields.owner.firstName,
            lastName: this.fields.owner.lastName,
            gender: Number(this.fields.owner.gender),
            birthdate: this.fields.owner.birthdate !== '' && this.fields.owner.birthdate !== null ? new Date(this.fields.owner.birthdate).toISOString() : '',
            email: this.fields.owner.email,
          },
          administrativeContact: {
            firstName: this.fields.administrativeContact.firstName,
            lastName: this.fields.administrativeContact.lastName,
            gender: Number(this.fields.administrativeContact.gender),
            birthdate: this.fields.administrativeContact.birthdate !== '' && this.fields.administrativeContact.birthdate !== null ? new Date(this.fields.administrativeContact.birthdate).toISOString() : '',
            email: this.fields.administrativeContact.email,
          }
        };


        // Disable submit button
        this.submitting = true;

        // Call UpdateGeneralInfo GraphQL
        this.$apollo.query({
          query: require('~/graphql/parkings/UpdateGeneralInfo.gql'), variables, fetchPolicy: 'no-cache'
        }).then(data => {

          if (data.data.updateProvider.success) {
            window.location.reload(true);
          } else {

            this.bus.$emit('submitData', {type: 'warning', message: 'Provider is NOT saved'})
            data.data.updateProvider.errors.forEach((error) => {
              this.bus.$emit('submitData', {type: 'warning', message: error.message})
            })
            this.submitting = false;
          }
        }).catch((error) => {
          this.bus.$emit('submitData', {type: 'warning', message: 'Provider is NOT saved'})
          this.bus.$emit('submitData', {type: 'warning', message: 'Error: ' + error.message})
          this.submitting = false;
        })
      },

      isDirty: () => false,
    }
	}
</script>

